import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../Image/Cliniclogo.png';
import styled from 'styled-components';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };
  useEffect(() => {
    setIsNavVisible(window.innerWidth > 768);
  }, [window.innerWidth]);
  return (
    <Container isScrolled={isScrolled}>
      <MainNavbar>
        <Link to={"/"}>
        <ClinicLogo>
          <img src={Logo} alt='logo' />
        </ClinicLogo>
        </Link>
        <NavToggle onClick={toggleNav}>
          <div></div>
          <div></div>
          <div></div>
        </NavToggle>
        <NavLinks isVisible={isNavVisible}>
          <NavLink to='/' onClick={toggleNav}>
            Home
          </NavLink>
          <NavLink to='/service-info' onClick={toggleNav}>
            Our Services
          </NavLink>
          <NavLink to='/about-us' onClick={toggleNav}>
            About Us
          </NavLink>
          <NavLink to='/contact-us' onClick={toggleNav}>
            Contact Us
          </NavLink>
        </NavLinks>
        <ButtonDiv isVisible={window.innerWidth > 768}>
          <AppointmentButton>
            <Link style={{ textDecoration: 'none', color: 'white' }}>
              Appointment
            </Link>
          </AppointmentButton>
        </ButtonDiv>

      </MainNavbar>
    </Container>
  );
};

export default Navbar;


const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 100;
  background-color: ${(props) => (props.isScrolled ? '#ffffff' : 'transparent')};
  transition: background-color 0.3s ease;
  @media (max-width: 769px) {
    background-color: white;
  }
`;

const MainNavbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  width: 80%;
  margin: auto;
  @media (max-width: 768px) {
  width: 100%;
  }
`;

const ClinicLogo = styled.div`
  img {
    width: 100px;
    height: auto;
  }
`;

const NavLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  opacity: ${(props) => (props.isVisible ? '1' : '0')};
  transition: visibility 0.3s, opacity 0.3s;
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    visibility: none;
    padding: 20px 10px;
  }
  
  @media (min-width: 768px) {
    visibility: visible;
    opacity: 1;
    flex-direction: row;
margin: auto;
width: 100%;
  }
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #6f8ba4;
  font-weight: bold;
white-space: nowrap;
  &:hover {
    color: #2879bd;
  }
`;
const ButtonDiv = styled.div`
//   width: 100%;
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
//   background-color: green;
  justify-content: flex-end;
teext-align: right;
  @media (max-width: 768px) {
    justify-content: flex-end;
    display: none;
  }
`;
const AppointmentButton = styled.button`
  background-color: #2879bd;
  color: white;
  border: none;
  font-family: 'Cairo';
  padding: 12px 30px 12px 30px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;

  &:hover {
    background-color: #23465a;
  }
`;

const NavToggle = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  div {
    width: 25px;
    height: 3px;
    background-color: #6f8ba4;
    margin: 4px 0;
  }

  @media (max-width: 768px) {
    display: flex;
    align-items: flex-end;
    // flex-direction: row;
  }
`;
